import { Link } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import type { AppRecordDoneWork } from '@shared/types/thread-work';
import type { AnyViewEnvelope } from '@shared/types/views';
import { ViewRouter } from '@/components/views/ViewRouter';
import { whenDone } from '@/components/activity/work-done';

/** While the action runs: it stays in place and says so. */
export const AppRecordRunning = () => (
  <p role="status" className="mt-2 inline-flex items-center gap-1.5 text-sm text-domino-inkSoft">
    <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden="true" />Domino travaille…
  </p>
);

/**
 * 29/10: one action done on the object, where it was done (« ✓ 16 h 12 ·
 * Identifier le dirigeant · Voir »). Its result opens in place; a tool run
 * opens on its own page.
 */
export const AppRecordDoneLine = ({ run, open, onToggle, now, who }: {
  run: AppRecordDoneWork;
  open: boolean;
  onToggle: () => void;
  now: Date;
  /** Who ran it, when it was not me. */
  who: string | null;
}) => {
  const failed = run.status === 'failed';
  return (
    <div className="mt-2">
      <p className="flex flex-wrap items-baseline gap-x-2 text-xs text-domino-inkSoft">
        <span className={failed ? undefined : 'font-semibold text-emerald-700'}>{failed ? 'Échec' : '✓'}</span>
        <span>{whenDone(run.finishedAt, now)} · {run.label}{who ? ` · ${who}` : ''}</span>
        {run.viewEnvelope ? (
          <button type="button" aria-expanded={open} onClick={onToggle} className="text-domino-aubergine underline underline-offset-2">
            {open ? 'Masquer' : 'Voir'}
          </button>
        ) : run.flowExecutionId && (
          <Link to={`/executions/${encodeURIComponent(run.flowExecutionId)}`} className="text-domino-aubergine underline underline-offset-2">Voir</Link>
        )}
      </p>
      {open && Boolean(run.viewEnvelope) && <div className="mt-3"><ViewRouter payload={run.viewEnvelope as AnyViewEnvelope} /></div>}
    </div>
  );
};
